var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{class:['footer', _vm.isUserFromAPP && 'app-layout_footer'],attrs:{"id":"Footer"}},[_c('IconLogo02',{staticStyle:{"margin":"0 0"}}),_c('IconCopyrightFooter',{staticClass:"copyright"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }